module.exports = __webpack_public_path__ + "media/react/components/Sequence/assets/minus-b3eddb11f9b02077577359881bd4dce6.svg";